import { InputLabel, Select } from "@mui/material";
import styled from "styled-components";

export const StyledMUISelect = styled(Select)`
  & .MuiInputBase-root {
    max-height: 30px !important;
  }
`;

export const SelectLabel = styled(InputLabel)`
  text-align: left;
  font: ${({ small }) => {
    if (small) return "normal normal 550 13px/18px Open Sans;";
    else return "normal normal normal 22px Open Sans;";
  }};
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
  text-transform: capitalize;
`;

export const StyledMenu = styled.div`
  text-align: left;
  font: ${({ small }) => {
    if (small) return "normal normal 550 13px/18px Open Sans;";
    else return "normal normal normal 16px Open Sans;";
  }};
  opacity: 0.5;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-transform: capitalize;
  margin-top: 2px;
`;

export const SelectMenu = styled.div`
  text-align: left;
  font: ${({ small }) => {
    if (small) return "normal normal 550 14px/19px Open Sans;";
    else return "normal normal normal 16px Open Sans;";
  }};
  opacity: 1;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 2px;
`;
